import React, { Component } from 'react';
import BgLeftImage from 'views/components/Login/BgLeftImage';
import '../../../index.scss';
import 'views/pages/Home/Home.scss';
import CopyrightFooter from 'views/components/Login/CopyrightFooter';
import { ThomasAlert } from './ThomasMessage';
import { Link } from 'react-router-dom';
import { ExitIcon } from '../Icons/EditIcons';
class NoAuthorizedPage extends React.Component<any> {
  constructor(props: any) {
    super(props);
  }
  componentDidMount() {}

  render() {
    return (
      <div className="site-wrap logged-out main-page">
        <BgLeftImage />
        <div className="reg-page__content-wrap">
          <div className="reg-page__primary">
            <div className="container reg-container">
              <div className="auth-container">
                <h2 className="text-center pt-0">Thomas Program Configuration Tool</h2>
                <div className="form-bg form-short">
                  <ThomasAlert />
                  <br />
                  <Link to="/logout">
                    <ExitIcon /> Logout
                  </Link>
                </div>

                <br />
                <br />
                <CopyrightFooter />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default NoAuthorizedPage;
